import * as React from "react"
import Svg, { Path } from "react-native-svg"
import { Icon } from 'native-base';

function SvgComponent(props) {
	return (
		<Icon
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 48.8 48.8"
			{...props}
		>
			<Path d="M43.04 24.4c0 10.3-8.35 18.65-18.65 18.65S5.75 34.7 5.75 24.4 14.1 5.75 24.4 5.75 43.05 14.1 43.05 24.4zM24.4 4.32c11.09 0 20.08 8.99 20.08 20.08S35.49 44.48 24.4 44.48 4.32 35.49 4.32 24.4 13.31 4.32 24.4 4.32zm0-4.32C10.92 0 0 10.92 0 24.4s10.92 24.4 24.4 24.4 24.4-10.92 24.4-24.4S37.87 0 24.4 0z" />
		</Icon>
	)
}

export default SvgComponent
